module.exports = __webpack_public_path__ + "static/media/Santiago Hopkins.dfa3ff5c.jpg";